import {EventType} from '../../../enum/event-type';
import {EmitterEvent} from './emitter-event';
import {Observable, Subscription} from 'rxjs';

export class ObservableEmitter {
  private _on$: Observable<any>;
  private _subscription: Subscription;
  private _emitter: any;

  constructor(
    private _eventType: EventType,
    private _callback,
    private _classType) {

    this._on$ = new Observable(
      observer => this._emitter = observer
    );

    this._subscription = this._on$.subscribe(
      (event: EmitterEvent) => {
        this._callback(event);
      }
    );
  }

  public get classType(): any {
    return this._classType;
  }

  public get eventType(): EventType {
    return this._eventType;
  }

  public emit(event: EmitterEvent) {
    this._emitter.next(event);
  }

  public unsubscribe(): void {
    this._subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /Users/mizunoe_jing/Documents/nice_day_current/bitbucket/starbright/src/app/service/event/prototype/observable-emitter.ts